import React from "react";

import ReCAPTCHA from "react-google-recaptcha";

const useRecaptcha = () => {
  const recaptchaRef = React.useRef<ReCAPTCHA>(null);

  const getRecaptchaValue = async () =>
    (await recaptchaRef?.current?.executeAsync()) ?? "";

  return {
    recaptchaRef,
    getRecaptchaValue,
  };
};

export default useRecaptcha;
